export default __webpack_public_path__ + "static/124-548f1c9ebf22c1d55ad158b7fc05f696.gif";